import { cva } from 'class-variance-authority'

// Note: Default tailwind intellisense will stop working if add parentheses inside the cva function
// Need to add custom regex to tailwind intellisense settings
const buttonVariants = cva(
	'relative inline-flex cursor-pointer select-none items-center justify-center overflow-hidden rounded-[8px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[cyan] focus-visible:ring-offset-2 disabled:pointer-events-none data-[loading=true]:pointer-events-none data-[full=true]:w-full',
	{
		variants: {
			variant: {
				primary:
					'border-2 border-o-500 bg-o-500 text-white hover:border-o-600 hover:bg-o-600 active:border-o-600 active:bg-o-400  active:shadow-[0px_0px_0px_2px_rgba(255,238,212,0.75)] disabled:border-n-300 disabled:bg-n-300 data-[loading=true]:border-o-400 data-[loading=true]:bg-o-400',
				'primary-inverse':
					'border-2 border-o-500 bg-white text-o-500 hover:border-o-600 hover:bg-o-600 hover:text-white active:border-o-600 active:bg-o-400 active:text-white  active:shadow-[0px_0px_0px_2px_rgba(255,238,212,0.75)] disabled:border-n-300 disabled:bg-white disabled:text-n-300 data-[loading=true]:border-o-400 data-[loading=true]:bg-o-400',
				secondary:
					'border-2 border-black bg-white text-n-950 hover:bg-n-950 hover:text-white active:bg-b-50% active:shadow-[0px_0px_0px_2px_rgba(255,238,212,0.75)] disabled:border-2 disabled:border-n-300 disabled:bg-transparent disabled:text-n-300',
				'secondary-inverse':
					'border-2 border-white bg-transparent text-white hover:bg-white hover:text-black active:border-white active:bg-w-50% active:shadow-[0px_0px_0px_2px_rgba(255,238,212,0.75)] disabled:border-n-300 disabled:text-n-300',
				'secondary-orange':
					'border-2 border-o-500 bg-white text-o-500 hover:bg-o-500 hover:text-white active:bg-o-400 active:shadow-[0px_0px_0px_2px_rgba(255,238,212,0.75)] disabled:border-2 disabled:border-n-300 disabled:bg-transparent disabled:text-n-300',
				tertiary:
					'typography-l1-emp gap-bff rounded-none bg-transparent !leading-[23px] text-black disabled:text-n-300 [&>[data-btn-text]]:border-b [&>[data-btn-text]]:hover:border-o-500 [&>[data-btn-text]]:active:border-[rgba(255,238,212,0.75)] [&>[data-button-test]]:disabled:border-none  [&>svg]:text-o-500 [&>svg]:disabled:text-n-300',
				'tertiary-inverse':
					'typography-l1-emp gap-bff rounded-none bg-transparent !leading-[23px] text-white disabled:text-n-300 [&>[data-btn-text]]:border-b [&>[data-btn-text]]:hover:border-o-500 [&>[data-btn-text]]:active:border-[rgba(255,238,212,0.75)] [&>[data-button-test]]:disabled:border-none [&>svg]:disabled:text-n-300',
				'pcs-primary':
					'border-2 border-black bg-black text-white hover:border-n-500 hover:bg-n-500 active:border-black active:bg-black/25  active:shadow-[0px_0px_0px_2px_rgba(255,238,212,0.75)] disabled:border-n-300 disabled:bg-n-300 data-[loading=true]:border-none data-[loading=true]:bg-b-25%',
				ghost:
					'hover:bg-b-5% active:bg-b-10% disabled:text-n-300 [&>svg]:disabled:text-n-300',
			},
			size: {
				none: '', // For tertiary buttons
				small: 'typography-l2-emp gap-4px px-16px py-[10px] ',
				medium: 'typography-l1-emp gap-8px px-good-friends py-[14px] ',
				large:
					'typography-l1-emp lg:py-18px gap-8px px-24px py-16px mdp:px-32px',
			},
		},
		defaultVariants: {
			variant: 'primary',
			size: 'small',
		},
	},
)

export default buttonVariants
